export default [
  {
    label: '社工日誌',
    value: '社工日誌',
  },
  {
    label: '關懷訪視',
    value: '關懷訪視',
  },
  {
    label: '電話問安',
    value: '電話問安',
  },
  {
    label: '電話問安(紀錄表)',
    value: '電話問安(紀錄表)',
  },
  {
    label: '就醫協助',
    value: '就醫協助',
  },
  {
    label: '餐飲服務',
    value: '餐飲服務',
  },
  {
    label: '其他登打',
    value: '其他登打',
  },
];
